import { render, staticRenderFns } from "./app-page.vue?vue&type=template&id=44a7ef2d&"
var script = {}
import style0 from "./app-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports